import { isNativeApp } from "./NativePayment";

export type Theme = "dark" | "light";


let activeTheme : Theme = "dark";

function updateTheme(firstLoad: boolean) {

    if (activeTheme == "dark") {
        document.body.classList.remove("light");
        document.body.classList.add("dark");
    }

    else if (activeTheme == "light") {
        document.body.classList.remove("dark");
        document.body.classList.add("light");
    }

    if (isNativeApp())
        appBridge.setTheme(activeTheme, false);
}

export function setTheme(name: Theme, firstLoad = false) {

    activeTheme = name;
    localStorage.setItem("theme", name);
    updateTheme(firstLoad);
}

export function toggleTheme() {

    if (activeTheme == "dark")
        setTheme("light");
    else
        setTheme("dark");
}

export function loadTheme() {

    setTheme(localStorage.getItem("theme") as Theme ?? "dark", true);
}